import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "./Motion";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./ui/accordion";
import { FAQS } from "../lib/seoData";

const HEADING = {
  de: "Häufige Fragen",
  en: "Frequently asked questions",
  fr: "Questions fréquentes",
};

export const FaqSection = ({ pageKey, className = "" }) => {
  const { lang } = useLang();
  const faqs = FAQS[pageKey] && FAQS[pageKey][lang];
  if (!faqs || !faqs.length) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section
      className={`border-t border-white/10 bg-obsidian py-24 md:py-32 ${className}`}
      data-testid={`faq-section-${pageKey}`}
    >
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <div className="mx-auto max-w-3xl px-6 md:px-12">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.3em] text-champagne">FAQ</span>
          <h2 className="mt-5 font-serif text-4xl font-light leading-tight text-white md:text-5xl">
            {HEADING[lang]}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-12 border-t border-white/10">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${pageKey}-${i}`}
                className="border-white/10"
                data-testid={`faq-item-${pageKey}-${i}`}
              >
                <AccordionTrigger className="py-6 font-serif text-lg font-light text-white hover:text-champagne hover:no-underline md:text-xl">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base font-light leading-relaxed text-white/60">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default FaqSection;
